// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

console.log('Application.js loaded');

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// jQueryを先に読み込む
const jQuery = require("jquery")
window.$ = window.jQuery = jQuery
console.log('jQuery loaded:', typeof jQuery !== 'undefined');

require('header')
require('login')
require('consert_dropdown')
require('consert_flip')

console.log('All JavaScript modules loaded');



// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
